import { MINCOL } from "../../../constants/const";

export const tgjHeader = [
    {accessor: 'jahr',
    Header: 'Jahr'},
    {accessor: 'idGruppe',
    Header: 'IDGruppe'},
    {accessor: 'gruppe',
    Header: 'Tagesgruppe',
    width: MINCOL},
    {accessor: 'anzTage',
    Header: 'Anzahl der Tage',
    width: MINCOL},
]
